var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Operation as LogOperation, Log, LogCategory } from '@augloop/logging';
import { TypeCategory } from '@augloop/schemas';
import { Annotation, SchemaObject, Signal, DeltaUpdateOperation, UpdateAnnotationMetaDataOperation } from '@augloop/types-core';
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.createHealthCheckRequest = function (clientMetadata) {
        return {
            payload: {},
            payloadSchema: { category: TypeCategory.Schema, schema: { name: 'HealthCheckRequest' } },
            requestedSchema: { category: TypeCategory.Schema, schema: { name: 'HealthCheckResponse' } },
            clientMetadata: clientMetadata
        };
    };
    Utils.isFeatureEnabled = function (hostCallbacks, featureName, defaultValue, scope) {
        if (defaultValue === void 0) { defaultValue = false; }
        if (scope === void 0) { scope = 'None'; }
        return hostCallbacks && hostCallbacks.isFeatureEnabled
            ? hostCallbacks.isFeatureEnabled('Microsoft.Office.AugLoop.' + featureName, scope)
                .catch(function () { return Promise.resolve(defaultValue); })
            : Promise.resolve(defaultValue);
    };
    Utils.convertWebSocketUrlToHttp = function (webSocketUrl) {
        return this.convertUrl(webSocketUrl, false);
    };
    Utils.convertServiceUrlToWebSocket = function (serviceUrl) {
        return this.convertUrl(serviceUrl, true);
    };
    Utils.convertUrl = function (url, convertToWs /** true for ws(s), false for http(s) */) {
        if (!url) {
            return url;
        }
        var urlOnColon = url.split(':');
        var serviceProtocol = urlOnColon[0].toLowerCase();
        if (serviceProtocol.indexOf(convertToWs ? 'http' : 'ws') == 0) {
            serviceProtocol = convertToWs ? serviceProtocol.replace('http', 'ws') : serviceProtocol.replace('ws', 'http');
            urlOnColon[0] = serviceProtocol;
            return urlOnColon.join(':');
        }
        return url;
    };
    Utils.uuidv4 = function () {
        return 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0;
            var v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    /**
     * Gets current time, expressed in milliseconds since 00:00 UTC 1 Jan 1970.
     * Note that older versions of some browsers can produce NaN as result.
     */
    Utils.getCurrentTimeMs = function () {
        return Date.now ? Date.now() : new Date().getTime();
    };
    return Utils;
}());
export { Utils };
var LogCountLimiter = /** @class */ (function () {
    function LogCountLimiter(id) {
        this.maxNumberOfLogs = 40;
        this.numberOfLogs = 0;
        this.id = id;
    }
    LogCountLimiter.prototype.log = function (logCode) {
        if (this.numberOfLogs < this.maxNumberOfLogs) {
            this.numberOfLogs++;
            logCode();
            if (this.numberOfLogs === this.maxNumberOfLogs) {
                var op = new LogOperation({
                    operationName: 'OnLastLog',
                    success: true,
                    resourceId: this.id,
                    resultDescription: "Limit for number of logs for id: ".concat(this.id, " reached - all next logs will be dropped"),
                });
                Log.warn(0x2224d0db /* tag_8jnd1 */, LogCategory.CoreDefault, op);
            }
        }
    };
    return LogCountLimiter;
}());
export { LogCountLimiter };
var coreBaseTypes = [SchemaObject.getTypeName(), Annotation.getTypeName(), Signal.getTypeName()];
export var buildArrayOfTypes = function (types) {
    var e_1, _a, e_2, _b;
    var finalTypes = new Set();
    try {
        for (var types_1 = __values(types), types_1_1 = types_1.next(); !types_1_1.done; types_1_1 = types_1.next()) {
            var singleType = types_1_1.value;
            if (typeof singleType === 'string') {
                if (coreBaseTypes.indexOf(singleType) === -1) {
                    finalTypes.add(singleType);
                }
            }
            else {
                try {
                    for (var _c = (e_2 = void 0, __values(__spreadArray([singleType.getTypeName()], __read(singleType.getBaseTypes()), false))), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var type = _d.value;
                        if (coreBaseTypes.indexOf(type) === -1) {
                            finalTypes.add(type);
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (types_1_1 && !types_1_1.done && (_a = types_1.return)) _a.call(types_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return Array.from(finalTypes);
};
/**
 * Returns the provided value if finite; otherwise, returns the default value.
 * @param value The preferred value, if finite.
 * @param defaultValue The failsafe value.
 */
export var getSafeNumber = function (value, defaultValue) {
    if (defaultValue === void 0) { defaultValue = 0; }
    return Number.isFinite(value)
        ? value
        : defaultValue;
};
export var isServerOp = function (op, serverInputTypes) {
    var e_3, _a;
    if (!Array.isArray(serverInputTypes) || serverInputTypes.length === 0) {
        return true;
    }
    if (DeltaUpdateOperation.typeGuard(op) || UpdateAnnotationMetaDataOperation.typeGuard(op)) {
        return true;
    }
    try {
        for (var _b = __values(op.items), _c = _b.next(); !_c.done; _c = _b.next()) {
            var opItem = _c.value;
            if (!opItem.body || SchemaObject.matchesTypesFor(opItem.body, serverInputTypes)) {
                return true;
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return false;
};
//# sourceMappingURL=utils.js.map